export const RETENTION_DAYS = 30;

export const EXPIRED_MESSAGE =
  "Expired — generated files are retained for 30 days.";

export const isSessionExpired = (
  s: { created_at?: string | null }
): boolean =>
  !!s.created_at &&
  Date.now() - new Date(s.created_at).getTime() >
    RETENTION_DAYS * 24 * 60 * 60 * 1000;
